import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="22" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.869 17.499A1 1 0 001.734 19h18.532a1 1 0 00.865-1.501L11.865 1.495a1 1 0 00-1.73 0L.869 17.499zM4.337 17a.5.5 0 01-.433-.75l6.663-11.512a.5.5 0 01.866 0l6.663 11.512a.5.5 0 01-.433.75H4.337zM10 14h2v2h-2v-2zm0-5a1 1 0 112 0v2a1 1 0 11-2 0V9z" fill="#9E5F00" /></svg>;